__turbopack_context__.v({
  "activeCategoryItem": "styles-module-scss-module__WKn7Aa__activeCategoryItem",
  "categoriesListContainer": "styles-module-scss-module__WKn7Aa__categoriesListContainer",
  "categoryItem": "styles-module-scss-module__WKn7Aa__categoryItem",
});
